import { DoqFaceSvgProps } from '../types';

const Success = ({ size, className }: DoqFaceSvgProps) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 144 144"
    fill="none"
    className={className}
    role="presentation"
  >
    <g clipPath="url(#clip0_1698_48215)">
      {/* mask to hide the bottom outline of the circle */}
      <mask id="bottom-mask-success">
        <circle cx="72" cy="72" r="72" fill="white" />
        <path d="M 108,135 A 72,72 0 0,1 36,135 L 72,72 Z" fill="black" />
      </mask>
      <circle
        cx="72"
        cy="72"
        r="72"
        fill="#76D1A5"
        mask="url(#bottom-mask-success)"
      />

      <mask
        id="mask0_1698_48215"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="320"
        height="320"
      >
        <circle cx="72" cy="72" r="72" fill="#FCBF4C" />
      </mask>
      <g mask="url(#mask0_1698_48215)">
        <path
          d="M11.9898 41.1911C11.777 41.7583 11.008 41.8392 10.6819 41.3286L5.37033 33.012C5.07616 32.5514 5.36955 31.9422 5.91307 31.8851L14.691 30.9625C15.2345 30.9054 15.6481 31.4402 15.4562 31.9519L11.9898 41.1911Z"
          fill="#FDC65E"
        />
        <path
          d="M67.5714 11.6379C68.1607 11.7786 68.6577 11.1862 68.4168 10.6304L64.4922 1.57634C64.2748 1.0749 63.6057 0.9775 63.2544 1.39616L57.581 8.15746C57.2297 8.57612 57.4418 9.21811 57.9734 9.34509L67.5714 11.6379Z"
          fill="#FDC65E"
        />
        <path
          d="M27.8665 37.9494C27.7554 38.545 27.0121 38.7581 26.6023 38.3119L19.9273 31.044C19.5576 30.6415 19.7407 29.9906 20.2661 29.84L28.7504 27.4071C29.2758 27.2565 29.776 27.7114 29.6758 28.2486L27.8665 37.9494Z"
          fill="#EF5D92"
        />
        <path
          d="M56.0073 22.9866C56.5632 23.2276 57.1555 22.7305 57.0148 22.1413L54.722 12.5433C54.595 12.0117 53.9531 11.7996 53.5344 12.1509L46.7731 17.8243C46.3544 18.1756 46.4518 18.8447 46.9533 19.062L56.0073 22.9866Z"
          fill="#EF5D92"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M43.5842 31.0524C43.6099 31.6576 42.9336 32.0325 42.434 31.69L34.2951 26.1099C33.8443 25.8008 33.8764 25.1255 34.3544 24.8605L42.074 20.5815C42.552 20.3165 43.1417 20.6472 43.1649 21.1932L43.5842 31.0524Z"
          fill="#2974C4"
        />
        <path
          d="M64.7852 -0.443673C64.3911 -0.763382 63.8125 -0.703143 63.4927 -0.309152L63.4899 -0.305773L63.4789 -0.292272C63.4687 -0.279875 63.4529 -0.260722 63.4316 -0.235018C63.3889 -0.183608 63.324 -0.106004 63.2371 -0.00384427C63.0633 0.200474 62.8018 0.502966 62.455 0.890438C61.7613 1.66544 60.7268 2.7801 59.3714 4.12901C56.6599 6.82747 52.6677 10.4598 47.554 14.1853C37.3203 21.6407 22.6384 29.4378 4.76791 30.9177C4.2621 30.9596 3.88602 31.4036 3.92791 31.9094C3.96979 32.4152 4.41379 32.7913 4.91959 32.7494C23.2361 31.2326 38.2355 23.2479 48.6362 15.6708C53.8398 11.8799 57.9031 8.18325 60.6679 5.43177C62.0506 4.05572 63.1094 2.91517 63.8245 2.11621C64.182 1.71671 64.4538 1.40253 64.6371 1.18693C64.7288 1.07912 64.7984 0.995953 64.8457 0.939078C64.8693 0.910638 64.8873 0.888774 64.8997 0.873685L64.914 0.856163L64.918 0.851262L64.9192 0.849786C64.9196 0.849319 64.9199 0.848964 64.2062 0.26999L64.9199 0.848964C65.2396 0.454818 65.1793 -0.123915 64.7852 -0.443673Z"
          fill="#540656"
        />
        <path
          d="M132.111 40.9345C132.324 41.5017 133.093 41.5826 133.419 41.072L138.73 32.7554C139.024 32.2948 138.731 31.6856 138.188 31.6285L129.41 30.7059C128.866 30.6488 128.452 31.1836 128.644 31.6953L132.111 40.9345Z"
          fill="#FDC65E"
        />
        <path
          d="M76.5292 11.3813C75.9399 11.522 75.4429 10.9297 75.6838 10.3738L79.6084 1.31975C79.8258 0.818305 80.4948 0.720909 80.8461 1.13957L86.5195 7.90087C86.8708 8.31953 86.6587 8.96152 86.1272 9.0885L76.5292 11.3813Z"
          fill="#FDC65E"
        />
        <path
          d="M116.234 37.6928C116.345 38.2884 117.089 38.5015 117.498 38.0553L124.173 30.7874C124.543 30.3849 124.36 29.734 123.834 29.5834L115.35 27.1505C114.825 26.9999 114.325 27.4548 114.425 27.992L116.234 37.6928Z"
          fill="#EF5D92"
        />
        <path
          d="M88.0933 22.73C87.5374 22.971 86.9451 22.4739 87.0858 21.8847L89.3786 12.2867C89.5055 11.7551 90.1475 11.543 90.5662 11.8943L97.3275 17.5677C97.7462 17.919 97.6488 18.5881 97.1473 18.8054L88.0933 22.73Z"
          fill="#EF5D92"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M100.516 30.7958C100.491 31.4011 101.167 31.7759 101.667 31.4334L109.805 25.8533C110.256 25.5442 110.224 24.8689 109.746 24.6039L102.027 20.3249C101.549 20.0599 100.959 20.3906 100.936 20.9366L100.516 30.7958Z"
          fill="#2974C4"
        />
        <path
          d="M79.3154 -0.700265C79.7095 -1.01997 80.2881 -0.959735 80.6079 -0.565744L80.6107 -0.562364L80.6217 -0.548864C80.6319 -0.536467 80.6477 -0.517314 80.669 -0.49161C80.7117 -0.4402 80.7766 -0.362595 80.8635 -0.260436C81.0373 -0.056118 81.2988 0.246374 81.6456 0.633846C82.3393 1.40885 83.3738 2.52351 84.7292 3.87242C87.4407 6.57088 91.4329 10.2032 96.5466 13.9287C106.78 21.3841 121.462 29.1813 139.333 30.6611C139.838 30.703 140.215 31.147 140.173 31.6528C140.131 32.1586 139.687 32.5347 139.181 32.4928C120.865 30.976 105.865 22.9914 95.4644 15.4142C90.2608 11.6233 86.1975 7.92666 83.4327 5.17518C82.05 3.79913 80.9912 2.65857 80.2761 1.85962C79.9186 1.46012 79.6468 1.14594 79.4635 0.930336C79.3718 0.822531 79.3022 0.739362 79.2549 0.682486C79.2313 0.654046 79.2133 0.632182 79.2009 0.617093L79.1866 0.599572L79.1826 0.59467L79.1814 0.593195C79.181 0.592727 79.1807 0.592372 79.8944 0.0133985L79.1807 0.592372C78.861 0.198226 78.9213 -0.380507 79.3154 -0.700265Z"
          fill="#540656"
        />
        <rect x="36" y="54" width="72" height="90" fill="white" />
      </g>

      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M63.8998 82.8C65.888 82.8 67.4998 81.1882 67.4998 79.2C67.4998 77.2118 65.888 75.6 63.8998 75.6C61.9116 75.6 60.2998 77.2118 60.2998 79.2C60.2998 81.1882 61.9116 82.8 63.8998 82.8ZM76.9498 78.3C76.4527 78.3 76.0498 78.7029 76.0498 79.2C76.0498 79.697 76.4527 80.1 76.9498 80.1H83.2498C83.7469 80.1 84.1498 79.697 84.1498 79.2C84.1498 78.7029 83.7469 78.3 83.2498 78.3H76.9498Z"
        fill="#2974C4"
      />
      <path
        d="M67.4117 28.249C67.1215 27.9222 66.6512 27.9222 66.361 28.249C63.6336 31.3225 63.6336 36.3055 66.361 39.379C66.5476 39.5967 66.8238 39.684 67.0836 39.6074C67.3434 39.5307 67.5463 39.3021 67.6143 39.0094C67.6823 38.7167 67.6048 38.4054 67.4117 38.1952C66.3802 37.0332 65.8007 35.457 65.8007 33.8135C65.8007 32.17 66.3802 30.5938 67.4117 29.4318C67.7011 29.105 67.7011 28.5759 67.4117 28.249Z"
        fill="#D12E69"
      />
      <path
        d="M76.5972 28.2488C76.3079 28.5754 76.3079 29.1049 76.5972 29.4316C77.6257 30.5924 78.2036 32.1671 78.2036 33.809C78.2036 35.451 77.6257 37.0256 76.5972 38.1865C76.399 38.3951 76.3176 38.7092 76.3847 39.0056C76.4519 39.3019 76.657 39.5332 76.9195 39.6087C77.1821 39.6843 77.4602 39.592 77.6448 39.3681C80.3646 36.2976 80.3646 31.3194 77.6448 28.2488C77.3555 27.9223 76.8865 27.9223 76.5972 28.2488Z"
        fill="#D12E69"
      />
      <path
        d="M81.086 23.8767C81.3532 23.8017 81.6373 23.8872 81.8291 24.1004V24.0998C84.1795 26.6224 85.4999 30.0438 85.4999 33.6112C85.4999 37.1787 84.1795 40.6001 81.8291 43.1226C81.6373 43.3359 81.3532 43.4214 81.086 43.3463C80.8188 43.2712 80.6101 43.0473 80.5402 42.7605C80.4703 42.4738 80.5499 42.1688 80.7486 41.9629C85.0392 37.3578 85.0392 29.8652 80.7486 25.2601C80.5499 25.0542 80.4703 24.7493 80.5402 24.4625C80.6101 24.1757 80.8188 23.9518 81.086 23.8767Z"
        fill="#EF5D92"
      />
      <path
        d="M62.1778 24.0905C62.4768 23.7698 62.9615 23.7698 63.2604 24.0905C63.5593 24.4113 63.5593 24.9312 63.2604 25.252C58.9596 29.8641 58.9596 37.3688 63.2604 41.9809C63.5506 42.3033 63.5465 42.8156 63.2511 43.1325C62.9558 43.4493 62.4782 43.4538 62.1778 43.1425C59.823 40.616 58.5 37.1894 58.5 33.6165C58.5 30.0435 59.823 26.6169 62.1778 24.0905Z"
        fill="#EF5D92"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M76.5008 45.5684L79.1998 54H64.7998L70.1998 37.1307H73.7998L76.4565 45.43L76.5807 45.5091L76.5008 45.5684ZM70.6219 41.7163L71.5136 38.9307H72.486L74.0829 43.9192L70.6219 41.7163ZM67.5509 52.2H76.7336L74.9731 46.7003L67.5509 52.2ZM70.1636 43.5583L68.5649 49.2084L73.4054 45.6217L70.1636 43.5583Z"
        fill="#475362"
      />
      <path
        d="M72 37.8C74.2368 37.8 76.05 35.9867 76.05 33.75C76.05 31.5132 74.2368 29.7 72 29.7C69.7632 29.7 67.95 31.5132 67.95 33.75C67.95 35.9867 69.7632 37.8 72 37.8Z"
        fill="#141414"
      />
      <path
        d="M79.2591 50.6666C79.1735 50.5027 79.0039 50.4 78.819 50.4H65.181C64.9961 50.4 64.8265 50.5027 64.7409 50.6666L63 54H81L79.2591 50.6666Z"
        fill="#141414"
      />
      <path
        d="M71.9678 31.3852C73.3857 31.4871 74.4613 32.7052 74.387 34.1248L74.3535 34.7659C74.3405 35.0141 74.5312 35.2258 74.7793 35.2388C75.0275 35.2518 75.2393 35.0611 75.2522 34.8129L75.2858 34.1719C75.3857 32.2626 73.9392 30.6246 72.0323 30.4875L71.9678 31.3852Z"
        fill="white"
      />
      <g opacity="0.5">
        <path
          d="M43.1992 109.35C43.1992 109.101 43.4007 108.9 43.6492 108.9H100.349C100.598 108.9 100.799 109.101 100.799 109.35V110.25C100.799 110.499 100.598 110.7 100.349 110.7H43.6492C43.4007 110.7 43.1992 110.499 43.1992 110.25V109.35Z"
          fill="#2974C4"
        />
        <path
          d="M43.1992 124.65C43.1992 124.401 43.4007 124.2 43.6492 124.2H100.349C100.598 124.2 100.799 124.401 100.799 124.65V125.55C100.799 125.799 100.598 126 100.349 126H43.6492C43.4007 126 43.1992 125.799 43.1992 125.55V124.65Z"
          fill="#2974C4"
        />
        <path
          d="M43.6492 116.1C43.4007 116.1 43.1992 116.301 43.1992 116.55V117.45C43.1992 117.699 43.4007 117.9 43.6492 117.9H100.349C100.598 117.9 100.799 117.699 100.799 117.45V116.55C100.799 116.301 100.598 116.1 100.349 116.1H43.6492Z"
          fill="#2974C4"
        />
        <path
          d="M43.1992 131.85C43.1992 131.601 43.4007 131.4 43.6492 131.4H100.349C100.598 131.4 100.799 131.601 100.799 131.85V132.75C100.799 132.999 100.598 133.2 100.349 133.2H43.6492C43.4007 133.2 43.1992 132.999 43.1992 132.75V131.85Z"
          fill="#2974C4"
        />
      </g>
      <g clipPath="url(#clip1_1698_48215)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M82.8002 89.9999C82.8002 95.9646 77.9649 100.8 72.0002 100.8C66.0355 100.8 61.2002 95.9646 61.2002 89.9999H82.8002Z"
          fill="#2974C4"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_1698_48215">
        <rect width="144" height="144" fill="white" />
      </clipPath>
      <clipPath id="clip1_1698_48215">
        <rect
          width="32.4"
          height="14.4"
          fill="white"
          transform="translate(55.7998 86.3999)"
        />
      </clipPath>
    </defs>
  </svg>
);

export { Success };
